import { util } from '@/api/util';
export const getPositionByUnit = (orgId) => {
    console.log('orgId', orgId);
    return [];
};
export const buildContactItem = (params) => {
    const { id, value, contactItemType, type, isDefault } = params;
    const _lastUpdateTime = Date.now();
    return {
        id: util.getUnique(id, 'MOBILE', value),
        contactId: id,
        contactItemVal: value,
        contactItemType,
        contactItemRefer: '',
        isDefault: isDefault ? 1 : 0,
        type,
        _lastUpdateTime,
    };
};
export const transOrg2EntityOrg = (params) => {
    const { list: _list, _lastUpdateTime = Date.now(), _account, contactUtil } = params;
    const list = Array.isArray(_list) ? _list : [_list];
    const mainCompanyId = contactUtil.getCurrentCompanyId(_account);
    const entityOrgList = [];
    const needDeleteOrgIds = [];
    list.forEach(item => {
        if (![0, 7].includes(item.showCode || 0)) {
            needDeleteOrgIds.push(item.unitId);
            return;
        }
        const { orgId } = item;
        const { type } = item;
        let id = item.unitId + '';
        let parent = item.parentUnitId + '' || (mainCompanyId === orgId ? '-1' : `${orgId}_-1`);
        const orgName = item.unitName;
        const orgRank = item.unitRank;
        const visibleCode = item.showCode === undefined ? 0 : item.showCode;
        const originId = item.oriUnitId + '';
        if (type === 99) {
            id = mainCompanyId === orgId ? '-1' : `${orgId}_-1`;
            parent = '-2';
        }
        const orgPYName = util.toPinyin(orgName);
        entityOrgList.push({
            id,
            parent,
            orgName,
            orgPYName,
            orgRank,
            type,
            visibleCode,
            originId,
            enterpriseId: item.orgId,
            _lastUpdateTime,
        });
    });
    return { entityOrgList, needDeleteOrgIds };
};
export const transformOrgData = (config) => {
    const { level = 9999, orgId = '-1', orgAllList, orgAllMap, contactUtil } = config;
    let children = [];
    const mainCompanyId = contactUtil.getCurrentCompanyId(config._account);
    let orgList = orgAllList.filter(item => {
        if (orgId === '-1') {
            return item.parent === orgId || item.parent === `${mainCompanyId}_-1`;
        }
        return item.parent === orgId;
    });
    const org = (orgAllMap[orgId] || {});
    if (orgList.length && level > 0) {
        children = orgList.map(item => {
            const res = transformOrgData({
                orgId: item.id,
                level: level - 1,
                orgAllList,
                orgAllMap,
                contactUtil,
            });
            orgList = orgList.concat(res.orgList);
            return res;
        });
    }
    orgList.unshift(org);
    return {
        org,
        children,
        orgList,
    };
};
